export default defineNuxtPlugin(() => {
  const { public: config } = useRuntimeConfig()

  // Load recaptcha during idle time to prevent blocking interactions
  if (typeof window !== 'undefined') {
    const loadRecaptcha = () => {
      useHead({
        script: [
          {
            key: 'recaptcha-init',
            src: `https://www.google.com/recaptcha/api.js?render=${config.recaptchaSiteKey}`,
            async: true,
            defer: true
          }
        ]
      })
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadRecaptcha, { timeout: 2000 })
    } else {
      setTimeout(loadRecaptcha, 2000)
    }
  }

  const getToken = async (action: string): Promise<string> => {
    return new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(config.recaptchaSiteKey, { action })
          .then((token: string) => {
            resolve(token) // this is the token you send to your backend
          })
          .catch((err: Error) => reject(err))
      })
    })
  }

  const provided: {
    recaptcha?: {
      getToken: (action: string) => Promise<string>
    }
  } = {
    recaptcha: {
      getToken
    }
  }

  return {
    provide: provided
  }
})
